import "global.css";
import * as React from "react";
import { Route, Switch } from "react-router-dom"
import * as RouteConstants from "routes/constants";
import PageNotFound from "routes/page-not-found";
import Login from "routes/login";
import Logout from "routes/logout";

const App = () => {
    return (
        <Switch>
            <Route
                path={RouteConstants.PAGE_PATH.LOGIN}
                component={Login}
            />
            <Route
                path={RouteConstants.PAGE_PATH.LOG_OUT}
                component={Logout}
            />
            <Route
                path={RouteConstants.PAGE_PATH.PAGE_NOT_FOUND}
                component={PageNotFound}
            />
        </Switch>
    );
};

export default App;